import { useNavigate, useSearchParams } from 'react-router-dom';

import useAuth from '../../auth/useAuth';
import Layout from '../UI/introGameLayout/layout';

import IntroVideo from './videos/intro.mp4';

import './styles.css';
import Video from '../UI/introGameLayout/video';

export default function ClassificationIntro() {
  const navigate = useNavigate();

  const [searchParams] = useSearchParams();
  const isOverview = searchParams.has('overview');

  const { isInstructor } = useAuth();

  const handleContinueButtonClick = () => {
    let redirectUrl;
    if (isOverview) {
      redirectUrl = `${isInstructor() ? '/instructor/settings/' : '/'}assignments`;
    } else {
      redirectUrl = '/classification/level/1/';
    }
    navigate(redirectUrl);
  }

  return(
    <Layout
      isHeaderVisible={true}
      isContentVertical={true}
      backgroundColor={'#3A507B'}
    >
      <div className="intro-video-wrapper">
        <Video videoSrc={IntroVideo} />
        <button className="intro-button" onClick={handleContinueButtonClick}>Continue</button>
      </div>
    </Layout>
  );
}
